<script setup>
import VCancel from "@/Components/VCancel.vue";
import FosteringContactFormLayout from "@/Layouts/FosteringContactFormLayout.vue";
import AdditionalComments from "@/Pages/SouthWestBrochure/Partials/AdditionalComments.vue";
import ContactDetails from "@/Pages/SouthWestBrochure/Partials/ContactDetails.vue";
import Details from "@/Pages/SouthWestBrochure/Partials/Details.vue";
import { Head, usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

const page = usePage()

window.dataLayer.push({
    'event': 'formSubmission',
    'formName': 'South West Brochure Fostering Enquiry Form',
});

const { headerLogo, isLAReferral, firstExternalContactSources, providedLocalAuthority } = usePage().props

const flash = computed(function () {
    return page.props.flash
});

const cancel = () => {
    if (isLAReferral && providedLocalAuthority.la_website_url_cancel) {
        window.location = providedLocalAuthority.la_website_url_cancel;
    } else {
        window.location.href = 'http://fosterwithyourlocalcouncil.org.uk'
    }
}

const homeLink = computed(() => {
    if (isLAReferral && providedLocalAuthority.la_website_url_home) {
        return providedLocalAuthority.la_website_url_home;
    } else {
        return 'http://fosterwithyourlocalcouncil.org.uk';
    }
})

</script>

<template>

    <Head title="Fostering - South West" />
    <FosteringContactFormLayout layout="SW" title="Thank you" header-colour="white" footer-colour="footer">
        <template v-slot:header>

            <div class="d-none d-md-block">
                <a :href="homeLink">
                    <img :src="headerLogo" alt="Fostering South West Logo" class="py-4 px-4 img-position" height="150"
                        width="300" />
                </a>
            </div>
            <div class="d-sm-block d-md-none">
                <a :href="homeLink">
                    <img :src="headerLogo" alt="Fostering South West Logo" class="py-4 px-4 img-position" height="150"
                        width="300" />
                </a>
            </div>
        </template>
        <template v-slot:headerSecondary>
            <div class="d-none d-md-block ">
                <img src="/static/images/fostering-south-west-map.png" alt="Fostering South West Logo"
                    style="position: absolute; right: 0; top: 0;" class="pb-3" height="168" />
            </div>
        </template>
        <template v-slot:default>

            <div id="form-complete" data-form="contact">
                <p class="mt-3">
                    Thank you for registering your interest in fostering with Fostering South West. One of our
                    Recruitment Officers will contact you within 2 working days. If you would like to speak to someone
                    before this time, you can call us on <a href="tel:0300 456 0120">0300 456 0120</a> or email us at <a
                        href="mailto:info@fosterwithyourlocalcouncil.org.uk">info@fosterwithyourlocalcouncil.org.uk</a>
                    We are open Monday to Friday 9am to 5pm, excluding bank holidays.
                </p>
                <br>
                <p>
                    We also hold Fostering Information Sessions every 3 weeks, in the daytime and in the evening. If you
                    would like to come along, you can find the information on our website and social media.
                </p>
                <br>
                <p>
                    We look forward to speaking with you soon and sharing more information with you about the amazing
                    world of fostering. In the meantime, why not hear more from some of our foster carers and watch the video below!
                </p>
                <br>
                <br>
                <div class="d-flex justify-center">
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/eytZNLFDZUI?si=SIqMwrHmQiNbpffC" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
                <br>
                <br>
                <br>
                <p>
                    If you are contacting Fostering South West with a worry about a child, please search online for your
                    local 'Children's Services Helpdesk'. If urgent, please contact the police.
                </p>
                <br>
                <p>
                    If you are a young person looking for help or support, there is help available with Childline <a
                        href="0800 1111">0800 1111</a> and <a
                        href="http://www.childline.org.uk">http://www.childline.org.uk</a>.
                </p>            
                <br>
                <br>
                <p>
                    Best wishes
                </p>
                <p>Fostering South West</p>
                <img :src="headerLogo" alt="Fostering South West Logo" class="mt-3" height="84" />
            </div>
        </template>
        <template v-slot:footer>
            <v-row class="pa-0">
                <v-col cols="12" md="4">
                    <v-row>
                        <v-col cols="7" xl="8" class="d-flex align-center">
                            <v-icon size="16" class="mr-2">fa fa-phone</v-icon>
                            <p class="text-white text-no-wrap">0300 456 0120</p>
                        </v-col>
                        <v-col cols="12" class="d-flex pt-0">
                            <v-icon size="16" class="mt-1 mr-2">fa fa-envelope</v-icon>
                            <p class="text-white text-wrap">info@fosterwithyourlocalcouncil.org.uk</p>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="4">
                    <v-row class="align-items-center text-center">
                        <v-col>
                            <a class="sw-hyperlink"
                                href="https://www.fosterwithyourlocalcouncil.org.uk/terms-and-conditions"
                                target="_blank">
                                Terms & Conditions
                            </a>
                        </v-col>
                        <v-col cols="12">
                            <a class="sw-hyperlink" href="https://fosterwithyourlocalcouncil.org.uk/privacy-policy/">
                                Privacy Notice
                            </a>
                        </v-col>
                        <v-col>
                            <a class="sw-hyperlink" href="/static/documents/accessibility_statement_30_05_24.docx">
                                Accessibility Statement
                            </a>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="4">
                    <v-row class="justify-end text-end">
                        <v-col cols="12">
                            <div class="d-flex justify-end align-middle">
                                <v-icon size="16" class="mr-2 mt-1">far fa-copyright</v-icon>
                                <p class="text-white text-no-wrap text-right">Fostering South West - {{ new
                                    Date().getFullYear() }}</p>
                            </div>
                        </v-col>
                        <v-col cols="12">
                            <div class="d-flex justify-end align-middle">
                                <v-icon size="16" class="mt-1 mr-2">far fa-globe</v-icon>
                                <a class="sw-hyperlink" href="https://www.netready.biz/" target="_blank">
                                    Netready Ltd.
                                </a>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </template>
    </FosteringContactFormLayout>
</template>

<style scoped>
:deep(.far.fa-copyright),
:deep(.far.fa-globe) {
    display: flex;
}

.footer-link>a {
    text-decoration: none;
    color: white;
}
</style>

<style>
.img-position {
    object-fit: contain;
    object-position: left;
}

footer {
    border-top: 10px solid #94EADF !important;
    background-image: url('/static/images/heart-pin-sw.png') !important;
    background-position: 95% 50% !important;
    background-repeat: no-repeat !important;
}
</style>
